import _extends from "@babel/runtime/helpers/extends";
import { Chip } from '@mui/material';
export default function FormChip(props) {
    var value = props.value, _a = props.label, label = _a === void 0 ? value : _a;
    return /*#__PURE__*/ React.createElement(Chip, _extends({}, props, {
        label: label !== null && label !== void 0 ? label : value
    }));
}
